import React from 'react'
import { Formik, Form, Field } from 'formik'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import ReactRouterPropTypes from 'react-router-prop-types'
import * as Yup from 'yup'

import { useOOGlobals } from '../../OOGlobalsProvider/OOGlobalsProvider'
import { useRestaurant } from '../../RestaurantProvider/RestaurantProvider'
import ForgotPasswordSuccessModal from '../ForgotPasswordSuccessModal/ForgotPasswordSuccessModal'
import { EMAIL_PASSWORD_RESET } from './ForgotPassword.graphql'
import ButtonSpacer from '../../ButtonSpacer/ButtonSpacer'
import Error from '../../Error/Error'
import { PoweredByToastModal } from '../../PoweredByToastModal/PoweredByToastModal'
import Input from '../../Form/Input/Input'
import Button from '../../Button/Button'
import { ModeLink } from '../../ModeRouter/ModeRouter'
import { Notification } from '../../Notification/Notification'
import { emailSchema } from '../../../utils/form-schemas'

import './ForgotPasswordModal.css'

const ForgotPasswordModal = ({ onClose, location: { state = {} } }) => {
  const { toastwebBaseUri, routerBasename } = useOOGlobals()
  const { restaurantGuid } = useRestaurant()
  return (
    <Mutation mutation={EMAIL_PASSWORD_RESET}>
      {(mutate, { data, loading, called }) => {
        const { success } = data ? data.initiateEmailPasswordReset : {}
        return success ? (
          <ForgotPasswordSuccessModal onClose={onClose} />
        ) : (
          <PoweredByToastModal
            onClose={onClose}
            header={
              <React.Fragment>
                <h2 data-testid='forgot-password-header' styleName='header'>Forgot Password</h2>
                <p data-testid='forgot-password-description' styleName='description'>
                  Enter the email address on file and we will send instructions
                  to reset your password
                </p>
              </React.Fragment>
            }
          >
            <Formik
              initialValues={{ email: '' }}
              validationSchema={Yup.object().shape({
                email: emailSchema
              })}
              onSubmit={async ({ email }) => {
                const input = {
                  variables: {
                    input: {
                      email,
                      redirectUrl: `${toastwebBaseUri}${routerBasename}?mode=reset`,
                      restaurantGuid
                    }
                  }
                }
                mutate(input)
              }}
            >
              {({ isValid }) => (
                <Form>
                  {state.expired && (
                    <Notification>
                      Unfortunately, that link isn't working. Enter your email
                      to get a new link.
                    </Notification>
                  )}
                  <Field
                    data-testid='forgot-password-login-email'
                    autoFocus
                    id='login-email'
                    name='email'
                    type='text'
                    label='email'
                    component={Input}
                  />
                  {/* This code path only visible if success is false */}
                  {called && !loading && <Error />}
                  <Button
                    data-testid='forgot-password-button-submit'
                    type='submit'
                    style='primary'
                    responsive
                    disabled={!isValid}
                    loading={loading}
                  >
                    Send Instructions
                  </Button>
                  <ButtonSpacer vertical />
                  <ModeLink data-testid='forgot-password-button-login' style='secondaryWide' mode='login'>
                    Log In
                  </ModeLink>
                </Form>
              )}
            </Formik>
          </PoweredByToastModal>
        )
      }}
    </Mutation>
  )
}

ForgotPasswordModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  location: ReactRouterPropTypes.location
}

export default withRouter(ForgotPasswordModal)
